module.exports = __webpack_public_path__ + "img/canvas_bg1.90145e07.png";